import { Component } from "@angular/core";
import { Location } from "@angular/common";

@Component({
    selector: "app-tests",
    templateUrl: "./tests.component.html",
    styleUrls: ["./tests.component.scss"],
})
export class TestsComponent {
    constructor(private location: Location) {}

    loadBack() {
        this.location.back();
    }
}
